module.exports = __webpack_public_path__ + "static/img/Raiders.f01e7dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Raiders.svg
// module id = ak3R
// module chunks = 1